<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
    <el-form-item prop="name" required>
      <el-input placeholder="Имя" v-model="ruleForm.name"></el-input>
    </el-form-item>
    <el-row :gutter="20">
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item prop="phone" required>
          <el-input 
            placeholder="+7 (999) 999-99-99" 
            v-model="ruleForm.phone" 
            @input="formatPhone"
            @keypress="onlyNumbers"
            @paste.prevent="handlePaste"
            maxlength="18"
            style="width: 100%;">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-form-item prop="email" required>
          <el-input placeholder="Email" v-model="ruleForm.email" style="width: 100%;"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item prop="message" class="message-form-item">
      <el-input type="textarea" :rows="3" placeholder="Ваш вопрос или сообщение" v-model="ruleForm.message"></el-input>
    </el-form-item>
    <div class="d-flex feedback__form__footer">
      <div class="feedback__form__footer__text">Нажимая на кнопку, я соглашаюсь на <a href="#">обработку персональных данных и с правилами пользования платформой</a></div>
      <button type="button" class="btn btn-black" @click="submitForm('ruleForm')">Отправить</button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "FeedbackForm",
  data() {
    return {
      ruleForm: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: 'Введите имя', trigger: ['blur', 'change'] },
          { min: 2, message: 'Имя должно содержать минимум 2 символа', trigger: 'blur' },
          { max: 100, message: 'Имя не должно превышать 100 символов', trigger: 'blur' },
          { 
            pattern: /^[а-яА-ЯёЁa-zA-Z\s\-']+$/u, 
            message: 'Имя может содержать только буквы, пробелы, дефисы и апострофы', 
            trigger: 'blur' 
          }
        ],
        phone: [
          { required: true, message: 'Введите номер телефона', trigger: ['blur', 'change'] },
          { 
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('Введите номер телефона'));
                return;
              }
              // Удаляем все нецифровые символы для проверки
              const digitsOnly = value.replace(/\D/g, '');
              // Проверяем, что номер содержит 11 цифр (российский формат: +7 + 10 цифр)
              if (digitsOnly.length !== 11 || !digitsOnly.startsWith('7')) {
                callback(new Error('Введите корректный номер телефона'));
                return;
              }
              callback();
            }, 
            trigger: ['blur', 'change'] 
          }
        ],
        email: [
          { required: true, message: 'Введите email', trigger: ['blur', 'change'] },
          { type: 'email', message: 'Введите корректный email адрес', trigger: ['blur', 'change'] }
        ],
        message: [
          { max: 1000, message: 'Сообщение не должно превышать 1000 символов', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    onlyNumbers(event) {
      // Блокируем ввод всех символов кроме цифр
      const char = String.fromCharCode(event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      // Обрабатываем вставку текста
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      // Оставляем только цифры
      const digitsOnly = pastedText.replace(/\D/g, '');
      if (digitsOnly) {
        // Форматируем вставленный текст
        this.formatPhone(digitsOnly);
      }
    },
    formatPhone(value) {
      // Получаем значение из события или напрямую
      let inputValue = '';
      if (typeof value === 'string') {
        // Если передана строка напрямую (из handlePaste)
        inputValue = value;
      } else if (value && value.target) {
        // Если это событие input
        inputValue = value.target.value;
      } else {
        inputValue = '';
      }
      
      // Удаляем все нецифровые символы
      let digitsOnly = inputValue.replace(/\D/g, '');
      
      // Если пусто, очищаем поле
      if (!digitsOnly || digitsOnly.length === 0) {
        this.ruleForm.phone = '';
        return;
      }
      
      // Если начинается с 8, заменяем на 7
      if (digitsOnly.startsWith('8')) {
        digitsOnly = '7' + digitsOnly.slice(1);
      }
      
      // Если начинается не с 7, добавляем 7 в начало
      if (!digitsOnly.startsWith('7')) {
        digitsOnly = '7' + digitsOnly;
      }
      
      // Ограничиваем до 11 цифр (7 + 10 цифр)
      if (digitsOnly.length > 11) {
        digitsOnly = digitsOnly.slice(0, 11);
      }
      
      // Форматируем в формат +7 (999) 999-99-99
      let formatted = '+7';
      if (digitsOnly.length > 1) {
        const code = digitsOnly.slice(1, 4);
        const part1 = digitsOnly.slice(4, 7);
        const part2 = digitsOnly.slice(7, 9);
        const part3 = digitsOnly.slice(9, 11);
        
        if (code) {
          formatted += ` (${code}`;
          if (part1) {
            formatted += `) ${part1}`;
            if (part2) {
              formatted += `-${part2}`;
              if (part3) {
                formatted += `-${part3}`;
              }
            }
          } else {
            formatted += ')';
          }
        }
      }
      
      this.ruleForm.phone = formatted;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // Очищаем телефон от форматирования перед отправкой
          const phoneDigits = this.ruleForm.phone.replace(/\D/g, '');
          
          this.axios.post('feedbacks', {
            name: this.ruleForm.name.trim(),
            phone: phoneDigits,
            email: this.ruleForm.email.trim(),
            message: this.ruleForm.message ? this.ruleForm.message.trim() : '',
            hideLoader: true
          }).then(() => {
            this.$toastr.s('Спасибо! Мы свяжемся с вами в ближайшее время.');
            // Очистка формы и валидации
            this.$refs[formName].resetFields();
            this.$refs[formName].clearValidate();
          }).catch((error) => {
            this.$toastr.e(error.response?.data?.message || 'Произошла ошибка при отправке формы');
          });
        } else {
          // Показываем первую ошибку валидации
          const firstErrorField = Object.keys(this.$refs[formName].fields).find(key => {
            return this.$refs[formName].fields[key].validateMessage;
          });
          if (firstErrorField) {
            this.$toastr.e('Пожалуйста, заполните все поля корректно');
          }
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.demo-ruleForm ::v-deep .el-form-item {
  margin-bottom: 24px;
}

.demo-ruleForm ::v-deep .el-form-item__error {
  padding-top: 0;
  padding-bottom: 8px;
  line-height: 1.4;
}

.demo-ruleForm ::v-deep .el-form-item__content {
  line-height: normal;
}

.demo-ruleForm ::v-deep .message-form-item .el-form-item__error {
  margin-top: 12px;
}
</style>